import { render, staticRenderFns } from "./AppPageContainer.vue?vue&type=template&id=c5038cae&scoped=true"
import script from "./AppPageContainer.vue?vue&type=script&lang=js"
export * from "./AppPageContainer.vue?vue&type=script&lang=js"
import style0 from "./AppPageContainer.vue?vue&type=style&index=0&id=c5038cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5038cae",
  null
  
)

export default component.exports